var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304px",
    height: "126px",
    viewBox: "0 0 304 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0412 0.3305 46.084 0.3305 46.084 46.3735 0.0412 46.3735"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3---Mobile",
    transform: "translate(-35.000000, -330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(36.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(255.477100, 47.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3442,4.5505 C32.5962,1.8895 28.0192,0.3305 23.0712,0.3305 C22.9702,0.3305 22.8692,0.3305 22.7702,0.3445 C19.6222,0.3735 16.6192,1.0455 13.9022,2.2335 C5.7482,5.7665 0.0412,13.8905 0.0412,23.3455 C0.0412,36.0615 10.3542,46.3735 23.0712,46.3735 C24.2722,46.3735 25.4452,46.2875 26.5892,46.1025 C28.7782,45.7735 30.8652,45.1295 32.7962,44.2145 C38.6902,41.4675 43.2242,36.2895 45.1122,29.9675 C45.7412,27.8645 46.0842,25.6485 46.0842,23.3455 C46.0842,15.5785 42.2372,8.7125 36.3442,4.5505",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,75.2223 C240.5,92.6293 254.289,106.7333 271.281,106.7333",
    id: "Stroke-14",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.412,45.956 C294.412,52.283 289.283,57.412 282.956,57.412 C276.629,57.412 271.5,52.283 271.5,45.956 C271.5,39.629 276.629,34.5 282.956,34.5 C289.283,34.5 294.412,39.629 294.412,45.956 Z",
    id: "Stroke-30",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 226.5,
    y1: 38.5,
    x2: 188,
    y2: 0,
    id: "Stroke-4",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,69 L121,69 C117.687,69 115,71.687 115,75 L115,106.437 C115,109.75 117.687,112.437 121,112.437 L175.315,112.437 L190.254,125 L190.254,112.437 L192,112.437 C195.314,112.437 198,109.75 198,106.437 L198,75 C198,71.687 195.314,69 192,69",
    id: "Fill-57",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,88 C170.343,88 169,89.343 169,91 C169,92.656 170.343,94 172,94 C173.656,94 175,92.656 175,91 C175,89.343 173.656,88 172,88",
    id: "Fill-58",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,88 C154.343,88 153,89.343 153,91 C153,92.656 154.343,94 156,94 C157.656,94 159,92.656 159,91 C159,89.343 157.656,88 156,88",
    id: "Fill-59",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,88 C138.343,88 137,89.343 137,91 C137,92.656 138.343,94 140,94 C141.656,94 143,92.656 143,91 C143,89.343 141.656,88 140,88",
    id: "Fill-60",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.945083,24 L153.553915,24 C156.009829,24 158,25.9904053 158,28.4466074 L158,51.742463 C158,54.1976635 156.009829,56.1890705 153.553915,56.1890705 L113.308785,56.1890705 L102.239145,65.5 L102.239145,56.1890705 L100.945083,56.1890705 C98.4901713,56.1890705 96.5,54.1976635 96.5,51.742463 L96.5,28.4466074 C96.5,25.9904053 98.4901713,24 100.945083,24",
    id: "Fill-61",
    fill: "#E8ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.750507,38 C116.993354,38 118,39.0068725 118,40.25 C118,41.4931275 116.993354,42.5 115.750507,42.5 C114.507659,42.5 113.5,41.4931275 113.5,40.25 C113.5,39.0068725 114.507659,38 115.750507,38",
    id: "Fill-62",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.749493,38 C128.993354,38 130,39.0068725 130,40.25 C130,41.4931275 128.993354,42.5 127.749493,42.5 C126.506646,42.5 125.5,41.4931275 125.5,40.25 C125.5,39.0068725 126.506646,38 127.749493,38",
    id: "Fill-63",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.249493,38 C140.492341,38 141.5,39.0068725 141.5,40.25 C141.5,41.4931275 140.492341,42.5 139.249493,42.5 C138.006646,42.5 137,41.4931275 137,40.25 C137,39.0068725 138.006646,38 139.249493,38",
    id: "Fill-64",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2974374,51.1042842 C65.5377196,52.685391 67,55.295376 67,58.2479846 C67,59.1226823 66.8699971,59.965133 66.6311546,60.7652597 C65.9126116,63.1676552 64.1893176,65.135725 61.9490354,66.179719 C61.2153758,66.5273811 60.4212496,66.7722561 59.5898359,66.8972129 C59.1554852,66.9677531 58.7090412,67 58.2525194,67 C53.4192341,67 49.5,63.0809916 49.5,58.2479846 C49.5,54.6534608 51.6687302,51.5658183 54.767636,50.2235403 C55.8006047,49.7720834 56.9414051,49.5171312 58.1386409,49.5060463 C58.1759286,49.5 58.214224,49.5 58.2525194,49.5 C60.1330262,49.5 61.8734523,50.0925371 63.2974374,51.1042842",
    id: "Fill-65",
    fill: "#85A1F8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.5,
    y1: 107,
    x2: 0,
    y2: 76,
    id: "Stroke-66",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMessages);
export default __webpack_public_path__ + "static/media/mobileMessages.a42d1666088f5a64caf1e587ff595836.svg";
export { ForwardRef as ReactComponent };